import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  max-width: 100%;
`

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* Filho DIRETO de proposito: este rotulo e o <span> do proprio campo.
     Um 'span' solto tambem casaria com o <span> interno que o Select do
     Ant Design usa para exibir o valor escolhido — e o valor sairia com a
     cor do rotulo, mais apagada que o resto do texto. */

  > span {
    font-size: 12px;
    color: ${colors.grey500};
  }
`

export const HeaderBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  /* Em telas estreitas, empilha e alinha à esquerda: o botão "Recalcular agora" não é
     empurrado para fora da área visível pelo space-between. */
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const Carimbo = styled.span`
  font-size: 13px;
  color: ${colors.grey500};
`

export const TableWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;

  tr {
    cursor: pointer;
  }
`

/* Alterna tabela (desktop) x cards (telas estreitas). Dados pequenos: ambos no DOM, togglados por CSS. */
export const DesktopTabela = styled.div`
  @media (max-width: 992px) {
    display: none;
  }
`

export const MobileCards = styled.div`
  display: none;

  @media (max-width: 992px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`

export const TenantCard = styled.div`
  border: 1px solid ${colors.azulOpaco};
  border-radius: 8px;
  padding: 14px 16px;
  cursor: pointer;

  &:active {
    background: ${colors.azulOpaco};
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;

  strong {
    color: ${colors.primaryText};
    font-size: 15px;
  }
`

export const CardMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 12px;
`

export const MetricItem = styled.div`
  display: flex;
  flex-direction: column;

  span:first-child {
    font-size: 11px;
    color: ${colors.grey500};
  }

  span:last-child {
    font-size: 15px;
    font-weight: 600;
    color: ${colors.primaryText};
  }
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
`

export const MetricCard = styled.div`
  border: 1px solid ${colors.azulOpaco};
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MetricTitle = styled.span`
  font-size: 12px;
  color: ${colors.grey500};
`

export const MetricValue = styled.span`
  font-size: 22px;
  font-weight: 600;
  color: ${colors.primaryText};
`

export const MetricHint = styled.span`
  font-size: 11px;
  color: ${colors.grey500};
`

export const SectionTitle = styled.h3`
  margin: 8px 0 0;
  font-size: 16px;
  color: ${colors.primaryText};
`

export const ChartWrapper = styled.div`
  border: 1px solid ${colors.azulOpaco};
  border-radius: 8px;
  padding: 12px;
`

const corDelta = (positivo?: boolean, negativo?: boolean): string => {
  if (positivo) return colors.secondaryText
  if (negativo) return colors.errorText
  return colors.grey500
}

export const DeltaHint = styled.span<{
  positivo?: boolean
  negativo?: boolean
}>`
  display: block;
  font-size: 11px;
  color: ${props => corDelta(props.positivo, props.negativo)};
`
